import CardGiftcardRoundedIcon from "@mui/icons-material/CardGiftcardRounded";
import { styled } from "@mui/material/styles";

export const GiftIcon = styled(CardGiftcardRoundedIcon)(({ theme }) => ({
  color: theme.palette.action.active,
}));
